import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AuthLayout from './AuthLayout';
import { Form, Field, Input, Button, ErrorText, Footer } from './AuthForm';
import { useAuth } from '../../contexts/AuthContext';

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  async function handleSubmit(e) {
    e.preventDefault();
    setError(null);
    if (password.length < 8) {
      setError('La contraseña debe tener al menos 8 caracteres');
      return;
    }
    setSubmitting(true);
    try {
      await register({ name, email, password });
      navigate('/', { replace: true });
    } catch (err) {
      const raw = err?.response?.data?.error;
      const msg =
        typeof raw === 'string' ? raw :
        raw && typeof raw === 'object' ? (raw.message || raw.code || JSON.stringify(raw)) :
        err?.message || 'No se pudo crear la cuenta';
      setError(msg);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <AuthLayout
      eyebrow="OPS://AUTH/PROVISION"
      title="Solicitar acceso"
      subtitle="Creá tu identidad para operar la plataforma."
    >
      <Form onSubmit={handleSubmit} noValidate>
        {error && <ErrorText role="alert">{error}</ErrorText>}
        <Field>
          Nombre
          <Input
            type="text"
            autoComplete="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Tu nombre completo"
          />
        </Field>
        <Field>
          Email
          <Input
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="operador@arcana.intel"
          />
        </Field>
        <Field>
          Contraseña
          <Input
            type="password"
            autoComplete="new-password"
            required
            minLength={8}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Mínimo 8 caracteres"
          />
        </Field>
        <Button type="submit" disabled={submitting}>
          {submitting ? 'Creando perfil…' : 'Crear acceso'}
        </Button>
      </Form>
      <Footer>
        ¿Ya operás Arcana? <Link to="/login">Iniciar sesión</Link>
      </Footer>
    </AuthLayout>
  );
}
